import { useOutletContext } from "react-router-dom";

import SuperAdminDistributionChannelPipelinesView from "../../views/SuperAdminDistributionChannelView/SuperAdminDistributionChannelPipelinesView";

export default function SuperAdminDistributionChannelPipelines() {
	const context = useOutletContext();

	return <SuperAdminDistributionChannelPipelinesView {...context} />;
}
